import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';

import React from 'react';

interface ConfirmDeleteModal {
  isOpen: boolean;
  onClose: () => void;
  deleteFunction: (id: number) => void;
  docID: number;
  count: number;
  setCount: any;
}

function ConfirmDeleteModal({
  isOpen,
  onClose,
  deleteFunction,
  docID,
  count,
  setCount,
}: ConfirmDeleteModal) {
  return (
    <>
      <Modal isCentered isOpen={isOpen} onClose={onClose} size="xs">
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <Text textAlign="center">Do you want to delete this Document?</Text>
          </ModalBody>
          <ModalFooter justifyContent=" center">
            <Button
              onClick={onClose}
              bg="#002677"
              color="white"
              h="30px"
              w="fit-content"
              mr="5px"
            >
              Cancel
            </Button>
            <Button
              bg="#002677"
              color="white"
              h="30px"
              w="fit-content"
              onClick={() => {
                deleteFunction(docID);
                setCount(count + 1);
                onClose();
              }}
            >
              Confirm
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ConfirmDeleteModal;
